import { render, staticRenderFns } from "./LiveChatMp4Decision.vue?vue&type=template&id=2e21adc4&scoped=true&"
import script from "./LiveChatMp4Decision.vue?vue&type=script&lang=js&"
export * from "./LiveChatMp4Decision.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatMp4Decision.vue?vue&type=style&index=0&id=2e21adc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e21adc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
